import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../services/website-theme.service";
import { WebClientService } from "../../services/webclient-settings.service";
import { LocationStrategy } from "@angular/common";
let BuySellInfoModalComponent = class BuySellInfoModalComponent {
    constructor(sanitizer, themeService, location, webSettingsService) {
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.location = location;
        this.webSettingsService = webSettingsService;
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.backColor = '';
        this.textColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.themeService.getTheme().subscribe((data) => {
            this.backColor = this.themeService.getStyleAttribute('modal_back_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
    }
    close() {
        this.modal.destroy();
    }
    closeModal() {
        document.documentElement.style.overflowY = '';
        this.modal.destroy();
    }
};
BuySellInfoModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: LocationStrategy },
    { type: WebClientService }
];
BuySellInfoModalComponent = __decorate([
    Component({
        selector: 'ecd-buy-sell-info-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./buy-sell-info-modal.component.html")).default
    })
], BuySellInfoModalComponent);
export { BuySellInfoModalComponent };
